export default {"src":"/_next/static/media/br-logo.5e391297.svg","height":52,"width":65};